<p-button  [type]="type" [severity]="severity" [variant]="variant === 'outlined' || variant === 'text' ? variant : undefined"
    [label]="text" [icon]="icon" (click)="handleClick($event)"  [disabled]="disable" [rounded]="isRounded">
</p-button>

<!-- <p-button label="Secondary" variant="text" severity="secondary" /> -->
<!-- <p-button *ngIf="type === 'outline'" styleClass="p-button-outlined" (click)="handleClick($event)">
    <img alt="logo" src="assets/images/Google.png" style="width: 1.5rem; margin-right: 5px"/>
    <span class="ml-2 font-bold">Google</span>
</p-button> -->